import emojiData from 'app/constants/emoji'
import emoji from 'react-easy-emoji'
import './styles.scss'

function EmojiPicker({ onClick }) {
  return (
    <div className="sc_emoji_picker__content">
      {emojiData.map((category) => {
        return (
          <div className="sc_emoji_picker__category" key={category.name}>
            <div className="sc_emoji_picker__category__title">{category.name}</div>
            <div className="category_emojis_list">
              {category.emojis.map((emojiIcon) => {
                return (
                  <span key={emojiIcon} className="sc_emoji_picker__emoji" onClick={onClick}>
                    {emoji(emojiIcon)}
                  </span>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default EmojiPicker
